

















































import { defineComponent, PropType } from '@vue/composition-api';
import { UserIcon } from '@vue-hero-icons/solid';
import { DerivationContract } from '../../types';

export default defineComponent({
    name: 'DerivationContractPreview',
    components: {
        UserIcon,
    },
    props: {
        contract: {
            type: Object as PropType<DerivationContract>,
            required: true,
        },
    },
});
